import { render } from "./UserProfilePhoto.vue?vue&type=template&id=f1195348"
import script from "./UserProfilePhoto.vue?vue&type=script&lang=js"
export * from "./UserProfilePhoto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__